// import {font_f_title, font_s_lg} from '@xpertdox_js/xdstyle';

export default {
  // title: {
  //   ...font_f_title,
  //   ...font_s_lg,
  // }
  saveBtnContainer: {
    marginTop: '8px'
  }
}
